module.exports = __webpack_public_path__ + "static/media/security-check.e014a28c.svg";